import api from './client';
import { takeAdminSession } from './impersonation';

// نشستِ ادمینِ ذخیره‌شده (پشتیبانِ «ورود جایگزین») را برمی‌گرداند و true می‌دهد.
// برای «خروج» و همچنین وقتی نشستِ جایگزین از کار می‌افتد (به‌جای رفتن به صفحهٔ ورود).
export const restoreAdminSession = (setLoggedIn, setUserInfo) => {
  const b = takeAdminSession();
  if (!b) return false;
  if (b.access) {
    localStorage.setItem('access', b.access);
    api.defaults.headers.common.Authorization = 'Bearer ' + b.access;
  }
  if (b.refresh) {
    localStorage.setItem('refresh', b.refresh);
  }
  // نقشِ فعالِ نشستِ جایگزین نباید روی نشستِ ادمین بماند (وگرنه روتر هیچ صفحه‌ای نمی‌یابد)
  try { sessionStorage.removeItem('activeRole') } catch (e) { /* noop */ }
  if (b.user && setUserInfo) {
    setUserInfo(b.user);
  }
  if (setLoggedIn) {
    setLoggedIn(true);
  }
  return true;
};

export const getAccessToken = async (setLoggedIn, setUserInfo) => {
  const refresh = localStorage.getItem('refresh');
  if (!refresh) {
    setLoggedIn(false);
    return;
  }

  try {
    const { data } = await api.post('users/refresh/', { refresh });

    localStorage.setItem('access', data.tokens.access);
    if (data.tokens.refresh) {
      localStorage.setItem('refresh', data.tokens.refresh);
    }

    setLoggedIn(true);
    if (data.user) {
      setUserInfo(data.user);
    }
    // توجه: رفرشِ موفق توکنِ «ورود جایگزین» نباید نشست را به ادمین برگرداند /
    // پشتیبان تا لحظهٔ «خروج» صریح محفوظ می‌ماند.
  } catch (error) {
    console.error('Token refresh failed:', error);
    // اگر در «ورود جایگزین» بودیم، به‌جای صفحهٔ ورود به پنل ادمین برگرد.
    if (restoreAdminSession(setLoggedIn, setUserInfo)) return;
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    setLoggedIn(false);
  }
};

export const logout = async (setLoggedIn, setLoading, setUserInfo) => {
  // اگر در حالت ورودِ جایگزین هستیم: «خروج» = برگشت به پنل ادمین، نه خروج کامل از سامانه
  if (restoreAdminSession(setLoggedIn, setUserInfo)) {
    if (setLoading) setLoading(false);
    return;
  }

  const refresh = localStorage.getItem('refresh');

  try {
    if (refresh) {
      await api.post('users/logout/', { refresh });
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    sessionStorage.removeItem('activeRole');
    setLoggedIn(false);
    if (setLoading) setLoading(false);
  }
};
